export type ChildReport = {
  child_session_id: string;
  run_id?: string;
  started_at?: string | null;
};

/** Another run of the same child that opened before `than`; a startless run is older than a dated one; false when `than` has no start. */
export function isOlderRun(candidate: ChildReport, than: ChildReport) {
  return (
    candidate.run_id !== undefined &&
    candidate.run_id !== than.run_id &&
    than.started_at != null &&
    (candidate.started_at == null ||
      Date.parse(candidate.started_at) < Date.parse(than.started_at))
  );
}
